"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    root: {
        maxWidth: 100,
        maxHeight: 100,
        fill: 'currentColor',
        display: 'block',
        '& path': {
            transition: 'opacity 100ms linear'
        }
    }
};
//# sourceMappingURL=filter.style.js.map